






import { Component, Vue } from 'vue-property-decorator';
import { sessionModule } from '@/trials/store/modules/session';
import { SysConst as SC } from '@/trials/plugins/const';

import KnowledgeChunks from '@/trials/domain/objects/knowledgeChunks';
import KCListAndDetail from '@/trials/views/components/KCListAndDetail.vue';

@Component({ components: { KCListAndDetail } })
export default class PredictResultDataAfter extends Vue {
    /*----------------------------------*
     * Props
     *-----------------------------------*/
    /*----------------------------------*
     * Data
     *-----------------------------------*/
    private tableData: any[] = [];
    /*----------------------------------*
     * Computed
     *-----------------------------------*/
    public get kcList(): KnowledgeChunks | null {
        return sessionModule.getPredictPersonalChunksAfter;
    }
    /*----------------------------------*
     * ライフサイクルフック
     *-----------------------------------*/
    created() {
        const preprocessedPredictData = sessionModule.getPreprocessedPredictData;

        if (preprocessedPredictData === null) {
            return;
        }

        this.tableData = preprocessedPredictData.dataWithResult;
    }
    /*----------------------------------*
     * Methods
     *-----------------------------------*/

    // 行選択時の処理
    private async selectHandler(selected: any): Promise<void> {
        await sessionModule.getPersonalChunksForPredictSet({
            index: selected.item.index - 1,
            isPreprocessed: true,
        });
    }
}
